'use strict';

export const apiDomain = 'finodigital';
export const apiKey = 'Woj6a4zu9r5PKa8l1J7h';